'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { uniqueId } from 'lodash';
import { useMemo, useState } from 'react';
import { Dropdown } from '@src/components/Dropdown/Dropdown';
import { type DropdownItem } from '@src/components/Dropdown/Dropdown';
import { NutritionalFactsDefaults } from '@src/components/NutritionalFacts/NutritionalFacts.defaults';
import { type NutritionalFactsProps } from '@src/components/NutritionalFacts/NutritionalFacts.props';
import { NutritionalFactsContent } from '@src/components/NutritionalFacts/NutritionalFactsContent';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
export const NutritionalFacts = t0 => {
  const $ = _c(37);
  const props = t0 === undefined ? NutritionalFactsDefaults : t0;
  const {
    builderBlock,
    items,
    previewAllItems,
    heading,
    skipWrapper,
    singleColumn
  } = props;
  const [selectedFlavorName, setSelectedFlavorName] = useState(items?.[0]?.flavorName);
  let t1;
  bb0: {
    const defaultNutritionalInfo = items?.[0] || undefined;
    let t2;
    if ($[0] !== items || $[1] !== selectedFlavorName) {
      let t3;
      if ($[3] !== selectedFlavorName) {
        t3 = item => item.flavorName === selectedFlavorName;
        $[3] = selectedFlavorName;
        $[4] = t3;
      } else {
        t3 = $[4];
      }
      t2 = items.find(t3);
      $[0] = items;
      $[1] = selectedFlavorName;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const selectedNutritionalInfo = t2;
    if (!selectedFlavorName || !selectedNutritionalInfo) {
      t1 = defaultNutritionalInfo;
      break bb0;
    }
    t1 = selectedNutritionalInfo;
  }
  const nutritionalInfo = t1;
  let t2;
  if ($[5] !== items || $[6] !== nutritionalInfo?.flavorName) {
    t2 = () => {
      const dropdownItems = items.map(_temp);
      return <Dropdown selectedId={nutritionalInfo?.flavorName as string} items={dropdownItems} onItemIdSelected={id => {
        setSelectedFlavorName(id as string);
      }} />;
    };
    $[5] = items;
    $[6] = nutritionalInfo?.flavorName;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const renderDropdown = t2;
  let t3;
  if ($[8] !== builderBlock || $[9] !== items || $[10] !== nutritionalInfo || $[11] !== previewAllItems || $[12] !== singleColumn) {
    t3 = () => {
      const {
        edit
      } = getBuilderPreviewMode();
      const shouldShowAllItems = previewAllItems && edit;
      if (shouldShowAllItems) {
        return <>{items.map(info => <div key={uniqueId()} className="my-4 flex flex-col gap-2"><div className="font-semibold text-bodi-gray-dark uppercase">{info.flavorName}:</div><hr /><BuilderBlocks parentElementId={builderBlock?.id} dataPath={`component.options.${info?.flavorName}.subheading.content`} blocks={info?.blocksSubheading} /><NutritionalFactsContent singleColumn={singleColumn} nutritionalInfo={info} builderBlock={builderBlock} /></div>)}</>;
      }
      return <NutritionalFactsContent singleColumn={singleColumn} nutritionalInfo={nutritionalInfo} builderBlock={builderBlock} />;
    };
    $[8] = builderBlock;
    $[9] = items;
    $[10] = nutritionalInfo;
    $[11] = previewAllItems;
    $[12] = singleColumn;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const renderContent = t3;
  const t4 = !skipWrapper;
  let t5;
  if ($[14] !== t4) {
    t5 = cn({
      "rounded-3xl border border-gray-300 px-8 py-12 lg:p-16": t4
    });
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = heading ?? "";
  let t7;
  if ($[16] !== t6) {
    t7 = <div className="text-heading-display-2" dangerouslySetInnerHTML={{
      __html: t6
    }} />;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = builderBlock?.id;
  const t9 = `component.options.${nutritionalInfo?.flavorName}.subheading.content`;
  const t10 = nutritionalInfo?.blocksSubheading;
  let t11;
  if ($[18] !== t10 || $[19] !== t8 || $[20] !== t9) {
    t11 = <BuilderBlocks parentElementId={t8} dataPath={t9} blocks={t10} />;
    $[18] = t10;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t7) {
    t12 = <div className="flex flex-col gap-2">{t7}{t11}</div>;
    $[22] = t11;
    $[23] = t7;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== items.length || $[26] !== renderDropdown) {
    t13 = items.length > 1 && <div className="w-full shrink-0 lg:w-[270px]">{renderDropdown()}</div>;
    $[25] = items.length;
    $[26] = renderDropdown;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <div className="flex flex-col justify-between gap-4 border-b border-bodi-gray-butters pb-4 lg:flex-row lg:items-center lg:gap-0">{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== renderContent) {
    t15 = renderContent();
    $[31] = renderContent;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14 || $[34] !== t15 || $[35] !== t5) {
    t16 = <div className={t5}>{t14}{t15}</div>;
    $[33] = t14;
    $[34] = t15;
    $[35] = t5;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};
function _temp(item_0) {
  const name = item_0.flavorName ?? "";
  return {
    id: name,
    name
  };
}